<template>
  <div class="privacy-agreement-page" v-loading="loading">
    <div class="content-wrapper" v-if="content">
      <div class="agreement-content" v-html="content"></div>
    </div>
    <div class="empty-wrapper" v-else-if="!loading">
      <p>暂无内容</p>
    </div>
  </div>
</template>

<script>
import { queryConfig } from "@/api/config";

export default {
  name: "PrivacyAgreement",
  data() {
    return {
      loading: false,
      content: "",
    };
  },
  created() {
    this.fetchPrivacyPolicy();
  },
  methods: {
    async fetchPrivacyPolicy() {
      this.loading = true;
      try {
        const res = await queryConfig({
          businessKey: "",
          configKeyList: ["user_privacy_policy"],
        });
        // 假设返回的数据结构为 { code, data, message }
        // data 为配置列表，取第一条记录的 content/value 字段
        if (res && res.data) {
          const configData = Array.isArray(res.data) ? res.data : [res.data];
          if (configData.length > 0) {
            // 根据实际返回字段取内容：优先取 configValue / content / value
            this.content = configData[0].configValue || configData[0].content || configData[0].value || "";
          }
        }
      } catch (error) {
        console.error("获取隐私协议失败：", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.privacy-agreement-page {
  width: 100%;
  min-height: 600px;
  background: #ffffff;
  border-radius: 8px;
  padding: 30px;
  box-sizing: border-box;
}

.content-wrapper {
  width: 100%;
}

.agreement-content {
  line-height: 1.8;
  font-size: 14px;
  color: #333;
}

.agreement-content ::v-deep p {
  margin-bottom: 10px;
}

.agreement-content ::v-deep h1,
.agreement-content ::v-deep h2,
.agreement-content ::v-deep h3,
.agreement-content ::v-deep h4 {
  margin: 16px 0 10px;
  font-weight: bold;
}

.empty-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #999;
  font-size: 14px;
}
</style>
